import "csh-material-bootstrap/dist/csh-material-bootstrap.css";
import Header from "./Components/Header.js";
import BoardGroup from "./Components/BoardGroup.js";
import "./App.css";

function App() {
  return (
    <>
      <Header />
      
      <BoardGroup />
    </>
  );
}

export default App;
